import MortgageFeeTables from '@/components/Approval/@components/MortgageFee';
import {
  formatMortgageFeeViewAmount,
  parseMortgageFeeAttributes,
} from '@/utils/approval/mortgageFee';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 81 (구)근저당설정비용 지급 — 저장값으로 표를 다시 그림(레거시 조회와 동일) */
const MortgageFeeSlot = ({ data }: ContentExtraProps) => {
  const saved = parseMortgageFeeAttributes(data.attributes);
  if (!saved) return null;
  return (
    <ContentSlotRoot>
      <MortgageFeeTables
        renderCell={(key) => {
          const value = saved[key];
          return typeof value === 'number' || value === null
            ? formatMortgageFeeViewAmount(value)
            : value;
        }}
      />
    </ContentSlotRoot>
  );
};

export default MortgageFeeSlot;
